module.exports = __webpack_public_path__ + "img/img41.0eec5a37.png";